var map = {
	"./ACC.txt": 222,
	"./ACC_F1.txt": 223,
	"./ADANIENT.txt": 224,
	"./ADANIENT_F1.txt": 225,
	"./ADANIPORTS.txt": 226,
	"./ADANIPORTS_F1.txt": 227,
	"./AMBUJACEM.txt": 228,
	"./AMBUJACEM_F1.txt": 229,
	"./APOLLOTYRE.txt": 230,
	"./APOLLOTYRE_F1.txt": 231,
	"./ASHOKLEY.txt": 232,
	"./ASHOKLEY_F1.txt": 233,
	"./ASIANPAINT.txt": 234,
	"./ASIANPAINT_F1.txt": 235,
	"./AUROPHARMA.txt": 236,
	"./AUROPHARMA_F1.txt": 237,
	"./AXISBANK.txt": 238,
	"./AXISBANK_F1.txt": 239,
	"./BAJAJ-AUTO.txt": 240,
	"./BAJAJ-AUTO_F1.txt": 241,
	"./BAJAJFINSV.txt": 242,
	"./BAJAJFINSV_F1.txt": 243,
	"./BAJFINANCE.txt": 244,
	"./BAJFINANCE_F1.txt": 245,
	"./BANDHANBNK.txt": 246,
	"./BANDHANBNK_F1.txt": 247,
	"./BANKBARODA.txt": 248,
	"./BANKBARODA_F1.txt": 249,
	"./BANKNIFTY.txt": 250,
	"./BANKNIFTY_F1.txt": 251,
	"./BANKNIFTY_F2.txt": 252,
	"./BHARATFORG.txt": 253,
	"./BHARATFORG_F1.txt": 254,
	"./BHARTIARTL.txt": 255,
	"./BHARTIARTL_F1.txt": 256,
	"./BHEL.txt": 257,
	"./BHEL_F1.txt": 258,
	"./BOSCHLTD.txt": 259,
	"./BOSCHLTD_F1.txt": 260,
	"./BPCL.txt": 261,
	"./BPCL_F1.txt": 262,
	"./BRITANNIA.txt": 263,
	"./BRITANNIA_F1.txt": 264,
	"./CANBK.txt": 265,
	"./CANBK_F1.txt": 266,
	"./CIPLA.txt": 267,
	"./CIPLA_F1.txt": 268,
	"./CNX-IT.txt": 269,
	"./CNX-MIDCAP.txt": 270,
	"./CNX-NIFTY-JUNIOR.txt": 271,
	"./CNX100.txt": 272,
	"./CNX500.txt": 273,
	"./CNXENERGY.txt": 274,
	"./CNXFMCG.txt": 275,
	"./COALINDIA.txt": 276,
	"./COALINDIA_F1.txt": 277,
	"./DLF.txt": 278,
	"./DLF_F1.txt": 279,
	"./DRREDDY.txt": 280,
	"./DRREDDY_F1.txt": 281,
	"./EICHERMOT.txt": 282,
	"./EICHERMOT_F1.txt": 283,
	"./ESCORTS.txt": 284,
	"./ESCORTS_F1.txt": 285,
	"./FEDERALBNK.txt": 286,
	"./FEDERALBNK_F1.txt": 287,
	"./GAIL.txt": 288,
	"./GAIL_F1.txt": 289,
	"./GOLDBEES.txt": 290,
	"./GRASIM.txt": 291,
	"./GRASIM_F1.txt": 292,
	"./HCLTECH.txt": 293,
	"./HCLTECH_F1.txt": 294,
	"./HDFC.txt": 295,
	"./HDFCBANK.txt": 296,
	"./HDFCBANK_F1.txt": 297,
	"./HDFCLIFE.txt": 298,
	"./HDFCLIFE_F1.txt": 299,
	"./HDFC_F1.txt": 300,
	"./HEROMOTOCO.txt": 301,
	"./HEROMOTOCO_F1.txt": 302,
	"./HINDALCO.txt": 303,
	"./HINDALCO_F1.txt": 304,
	"./HINDPETRO.txt": 305,
	"./HINDPETRO_F1.txt": 306,
	"./HINDUNILVR.txt": 307,
	"./HINDUNILVR_F1.txt": 308,
	"./IBULHSGFIN.txt": 309,
	"./IBULHSGFIN_F1.txt": 310,
	"./ICICIBANK.txt": 311,
	"./ICICIBANK_F1.txt": 312,
	"./IDEA.txt": 313,
	"./IDEA_F1.txt": 314,
	"./INDIAVIX.txt": 315,
	"./INDIGO.txt": 316,
	"./INDIGO_F1.txt": 317,
	"./INDUSINDBK.txt": 318,
	"./INDUSINDBK_F1.txt": 319,
	"./INDUSTOWER.txt": 320,
	"./INDUSTOWER_F1.txt": 321,
	"./INFY.txt": 322,
	"./INFY_F1.txt": 323,
	"./IOC.txt": 324,
	"./IOC_F1.txt": 325,
	"./ITC.txt": 326,
	"./ITC_F1.txt": 327,
	"./JINDALSTEL.txt": 328,
	"./JINDALSTEL_F1.txt": 329,
	"./JSWSTEEL.txt": 330,
	"./JSWSTEEL_F1.txt": 331,
	"./JUBLFOOD.txt": 332,
	"./JUBLFOOD_F1.txt": 333,
	"./KOTAKBANK.txt": 334,
	"./KOTAKBANK_F1.txt": 335,
	"./LICHSGFIN.txt": 336,
	"./LICHSGFIN_F1.txt": 337,
	"./LT.txt": 338,
	"./LT_F1.txt": 339,
	"./LUPIN.txt": 340,
	"./LUPIN_F1.txt": 341,
	"./M&M.txt": 342,
	"./M&MFIN.txt": 343,
	"./M&MFIN_F1.txt": 344,
	"./M&M_F1.txt": 345,
	"./MARUTI.txt": 346,
	"./MARUTI_F1.txt": 347,
	"./MFSL.txt": 348,
	"./MFSL_F1.txt": 349,
	"./MUTHOOTFIN.txt": 350,
	"./MUTHOOTFIN_F1.txt": 351,
	"./NESTLEIND.txt": 352,
	"./NESTLEIND_F1.txt": 353,
	"./NIFTY-MIDCAP50.txt": 354,
	"./NIFTY.txt": 355,
	"./NIFTYAUTO.txt": 356,
	"./NIFTYBEES.txt": 357,
	"./NIFTYFINSERVICE.txt": 358,
	"./NIFTYINFRA.txt": 359,
	"./NIFTYMETAL.txt": 360,
	"./NIFTY_F1.txt": 361,
	"./NIFTY_F2.txt": 362,
	"./NMDC.txt": 363,
	"./NMDC_F1.txt": 364,
	"./NTPC.txt": 365,
	"./NTPC_F1.txt": 366,
	"./ONGC.txt": 367,
	"./ONGC_F1.txt": 368,
	"./PEL.txt": 369,
	"./PEL_F1.txt": 370,
	"./PFC.txt": 371,
	"./PFC_F1.txt": 372,
	"./PNB.txt": 373,
	"./PNB_F1.txt": 374,
	"./POWERGRID.txt": 375,
	"./POWERGRID_F1.txt": 376,
	"./RBLBANK.txt": 377,
	"./RBLBANK_F1.txt": 378,
	"./RECLTD.txt": 379,
	"./RECLTD_F1.txt": 380,
	"./RELIANCE.txt": 381,
	"./RELIANCE_F1.txt": 382,
	"./SAIL.txt": 383,
	"./SAIL_F1.txt": 384,
	"./SBIN.txt": 385,
	"./SBIN_F1.txt": 386,
	"./SHREECEM.txt": 387,
	"./SHREECEM_F1.txt": 388,
	"./SHRIRAMFIN.txt": 389,
	"./SHRIRAMFIN_F1.txt": 390,
	"./SIEMENS.txt": 391,
	"./SIEMENS_F1.txt": 392,
	"./SUNPHARMA.txt": 393,
	"./SUNPHARMA_F1.txt": 394,
	"./SUNTV.txt": 395,
	"./SUNTV_F1.txt": 396,
	"./TATACONSUM.txt": 397,
	"./TATACONSUM_F1.txt": 398,
	"./TATAMOTORS.txt": 399,
	"./TATAMOTORS_F1.txt": 400,
	"./TATAPOWER.txt": 401,
	"./TATAPOWER_F1.txt": 402,
	"./TATASTEEL.txt": 403,
	"./TATASTEEL_F1.txt": 404,
	"./TCS.txt": 405,
	"./TCS_F1.txt": 406,
	"./TECHM.txt": 407,
	"./TECHM_F1.txt": 408,
	"./TITAN.txt": 409,
	"./TITAN_F1.txt": 410,
	"./ULTRACEMCO.txt": 411,
	"./ULTRACEMCO_F1.txt": 412,
	"./UPL.txt": 413,
	"./UPL_F1.txt": 414,
	"./VEDL.txt": 415,
	"./VEDL_F1.txt": 416,
	"./VOLTAS.txt": 417,
	"./VOLTAS_F1.txt": 418,
	"./WIPRO.txt": 419,
	"./WIPRO_F1.txt": 420,
	"./ZEEL.txt": 421,
	"./ZEEL_F1.txt": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;